import Vue from 'vue';
import Vuex from 'vuex';
import axfUI from 'axf-ui/tools';
import banner from './modules/banner';
import tangParams from './modules/tang-params';
import getChargeProject from './modules/getChargeProject';
import chargeManagementSearch from './modules/chargeManagementSearch';
import receivables from './modules/receivables';
import clientDetailInfo from './modules/clientDetailInfo';
import partCharge from './modules/partCharge';
import setRepeatCharge from './modules/setRepeatCharge';
import global from './modules/global';
import student from './modules/student';
import setClientDisplayName from './modules/setClientDisplayName';

import printStore from './modules/print-store';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		axfUI,
		banner,
		tangParams,
		getChargeProject,
		global,
		chargeManagementSearch,
		printStore,
		receivables,
		clientDetailInfo,
		partCharge,
		setRepeatCharge,
		student,
		setClientDisplayName,
	},
	actions: {},
});
